import { mapActions } from 'vuex';
import Events from '_utils/events';
import UserService from '_services/rest/modules/user';

export default {
  name: 'user-delete',
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    deleteRow() {
      this.setToggle({ type: 'progress', bool: true });
      UserService.deleteUser(this.selectUser)
        .then(() => {
          this.close();
          Events.$emit('update:pagination', {
            search: '',
            skip: (this.$route.params.page - 1) * 10,
            take: 10,
            page: parseInt(this.$route.params.page, Number),
          });
          this.activeAlert({ message: 'Usuário deletado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
};
